(() => {
  'use-strict';

  const body = document.querySelector('body');

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;

      let timeoutMenu;
      const linkTriggers = element.querySelectorAll('[aria-controls].lvl-0');
      const siteHeader = element.closest('.js-site-header');

      // build categoryLink + replace real link by button for accessibility
      linkTriggers.forEach((linkTrigger) => {
        const href = linkTrigger.getAttribute('href');

        if (href) {
          linkTrigger.removeAttribute('href');
          linkTrigger.outerHTML = linkTrigger.outerHTML
            .replace(/^<a/, '<button')
            .replace(/^<\/a/, '</button');
        }
        else {
          linkTrigger.outerHTML = linkTrigger.outerHTML.replace(/^<span/, '<button').replace(/^<\/span/, '</button');
        }
      });

      function clickOutsideHandle(trigger, event) {
        let targetEl = event.target; // clicked element
        do {
          if (targetEl === element.closest('nav')) {
            // This is a click inside, does nothing, just return.
            return;
          }
          // Go up the DOM
          targetEl = targetEl.parentNode;
        } while (targetEl);
        // This is a click outside.
        const viewportWidth =
          window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth >= window.breakpointsDefinition['desktop']) {
          // eslint-disable-next-line no-use-before-define
          toggle(trigger, false);
        }
      }

      const toggle = (trigger, state) => {
        if (
          (trigger.target.getAttribute('aria-expanded') === 'true') !==
          state
        ) {
          // state change we do actions
          trigger.setAttribute('aria-expanded', state);
          trigger.target.classList.add('-isAnimated');
          trigger.target.setAttribute('aria-expanded', state);
          body.classList.toggle('-mainMenuSubLvlIsExpanded', state);
          body.classList.add('-withMenuSubLvlAnimation');
          const removeAnimatedClass = () => {
            trigger.target.classList.remove('-isAnimated');
            body.classList.remove('-withMenuSubLvlAnimation');
            trigger.target.addEventListener(
              'animationend',
              removeAnimatedClass,
            );
          };
          trigger.target.addEventListener('animationend', removeAnimatedClass);

          if (state === false) {
            // close actions
            trigger.links.forEach((link) => {
              link.removeEventListener('blur', link.blurLink);
            });
            document.removeEventListener('click', clickOutsideHandle);
          } else {
            // open actions
            trigger.links = trigger.target.querySelectorAll('a, button');
            trigger.links.forEach((link) => {
              link.blurLink = (event) => {
                // check if the new target is in the same parent or not
                const parentMenuItem = event.target.closest('.menu-item.lvl-0');
                if (
                  event.relatedTarget !== null &&
                  parentMenuItem !==
                    event.relatedTarget.closest('.menu-item.lvl-0')
                ) {
                  const parentTrigger =
                    parentMenuItem.querySelector('.menu-link.lvl-0');
                  toggle(parentTrigger, false);
                }
              };
              link.addEventListener('blur', link.blurLink);
            });
            document.addEventListener(
              'click',
              clickOutsideHandle.bind(null, trigger),
            );
          }
        }
      };

      const buttonTriggers = element.querySelectorAll(
        'button[aria-controls].lvl-0',
      );

      buttonTriggers.forEach((trigger) => {
        trigger.target = document.getElementById(
          trigger.getAttribute('aria-controls'),
        );

        const toggleAndCloseSiblings = () => {
          buttonTriggers.forEach((elt) => {
            // if element is not current or current is opened
            if (
              elt !== trigger ||
              elt.target.getAttribute('aria-expanded') === 'true'
            ) {
              toggle(elt, false);
            } else {
              // if current is closed
              toggle(elt, true);
            }
          });
        };

        const blurHandle = (event) => {
          const parentMenuItem = event.target.closest('.menu-item.lvl-0');
          if (
            event.relatedTarget !== null &&
            parentMenuItem !== event.relatedTarget.closest('.menu-item.lvl-0')
          ) {
            const parentTrigger =
              parentMenuItem.querySelector('.menu-link.lvl-0');
            toggle(parentTrigger, false);
          }
          event.target.blurListenerAttached = false;
          trigger.removeEventListener('blur', blurHandle);
        };
        const focusHandle = (event) => {
          if (!event.target.blurListenerAttached) {
            event.target.blurListenerAttached = true;
            event.target.addEventListener('blur', blurHandle);
          }
        };
        const clickHandle = (event) => {
          toggleAndCloseSiblings();
          event.preventDefault();
          if (!event.target.blurListenerAttached) {
            event.target.blurListenerAttached = true;
            event.target.addEventListener('blur', blurHandle);
          }
        };

        trigger.addEventListener('click', clickHandle);
        trigger.addEventListener('focus', focusHandle);
      });

      const calcButtonsPos = () => {
        if (siteHeader !== null) {
          const headerRect = siteHeader.getBoundingClientRect();
          const middleHeaderRect = headerRect.left + headerRect.width / 2;
          buttonTriggers.forEach((trigger) => {
            const triggerRect = trigger.getBoundingClientRect();
            const middleTriggerRect = triggerRect.left + triggerRect.width / 2;
            const deltaFromMiddleHeader = Math.round(
              middleTriggerRect - middleHeaderRect,
            );
            trigger.target.style.setProperty(
              '--arrow-delta-middle',
              `${deltaFromMiddleHeader}px`,
            );
          });
        }
      };

      window.addEventListener(
        'resize',
        () => {
          if (timeoutMenu) {
            window.cancelAnimationFrame(timeoutMenu);
          }
          /// Wrap this in requestAnimantionFrame to avoid performances issues
          timeoutMenu = window.requestAnimationFrame(() => {
            calcButtonsPos();
          });
        },
        false,
      );

      setTimeout(calcButtonsPos, 100);
    });
  }

  Drupal.behaviors.menuAccordion = {
    attach: () => {
      const elements = document.querySelectorAll('.js-menu-accordion');
      if (elements.length !== 0) {
        init(elements);
      }
    },
  };
})();
